<div class="modal-header">
    <h4 class="modal-title">Aksiyon {{data.actionId ? "Güncelle" : "Oluştur"}}</h4>
</div>
<div class="modal-body" *blockUI="'card-section'">
    <div class="card">
        <div class="card-body">
            <div class="media">
                <div class="avatar bg-primary mr-75">
                    <div class="avatar-content">{{ data.requestTask.title[0] + data.requestTask.title[1] }}</div>
                </div>
                <div class="media-body">
                    <h6 class="mb-25">{{ data.requestTask.title }}</h6>
                    <p class="card-text">{{ data.requestTask.startDate | date:'dd/MM/yyyy' }} - {{
                        data.requestTask.endDate |
                        date:'dd/MM/yyyy' }}</p>
                </div>
            </div>
            <!-- Form -->
            <form [formGroup]="actionForm" (ngSubmit)="onSubmit()" class="mt-2">
                <div class="row">
                    <div class="col-md-6 col-12">
                        <div class="form-group mb-2">
                            <label for="title">Başlık</label>
                            <input type="text" formControlName="title" class="form-control" placeholder="Başlık" />
                        </div>
                    </div>
                    <div class="col-md-6 col-12">
                        <div class="form-group mb-2">
                            <label for="type">Tür</label>
                            <ng-select [items]="kinds" formControlName="typeId" placeholder="Tür seç" bindValue="id"
                                bindLabel="typeName"></ng-select>
                        </div>
                    </div>
                    <div class="col-md-6 col-12">
                        <div class="form-group mb-2">
                            <label for="startDate">Başlangıç tarihi</label>
                            <ng2-flatpickr [config]="dateTimeStartOptions" formControlName="startDate"
                                [setDate]="date"></ng2-flatpickr>
                        </div>
                    </div>
                    <div class="col-md-6 col-12">
                        <div class="form-group mb-2">
                            <label for="endDate">Bitiş tarihi</label>
                            <ng2-flatpickr [config]="dateTimeEndOptions" formControlName="endDate"
                                [setDate]="date2"></ng2-flatpickr>
                        </div>
                    </div>
                    <div class="col-md-6 col-12">
                        <div class="form-group mb-2">
                            <label for="responsiblePerson">Sorumlu kişi</label>
                            <ng-select [searchable]="false" formControlName="responsiblePerson" bindLabel="name"
                                bindValue="'id'" placeholder="Sorumlu kişi seç">
                                <ng-option *ngFor="let user of persons" [value]="user.id">{{user.name + ' ' +
                                    user.lastName}}</ng-option>
                            </ng-select>

                        </div>
                    </div>
                    <div class="col-md-6 col-12">
                        <div class="form-group mb-2">
                            <label for="companyPerson">Firma sorumlu kişi</label>
                            <ng-select [searchable]="false" formControlName="companyPerson" bindLabel="name"
                                bindValue="'id'" placeholder="Firma sorumlu kişi seç">
                                <ng-option *ngFor="let user of selectedCompanyPerson" [value]="user.id">{{user.name + '
                                    ' +
                                    user.lastName}}</ng-option>
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-md-6 col-12">
                        <div class="form-group mb-2">
                            <label for="priority">Öncelik</label>
                            <select class="form-control" formControlName="priority">
                                <option value="1">Normal</option>
                                <option value="2">Acil</option>
                                <option value="3">Çok Acil</option>
                            </select>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="form-group mb-2">
                            <label for="description">Açıklama</label>
                            <quill-editor formControlName="description">
                                <div quill-editor-toolbar>
                                    <span class="ql-formats">
                                        <button class="ql-bold" [title]="'Bold'"></button>
                                        <button class="ql-italic" [title]="'italic'"></button>
                                        <button class="ql-underline" [title]="'underline'"></button>
                                    </span>
                                    <span class="ql-formats">
                                        <select class="ql-align" [title]="'Alignment'">
                                            <option selected></option>
                                            <option value="center"></option>
                                            <option value="right"></option>
                                            <option value="justify"></option>
                                        </select>
                                    </span>
                                    <span class="ql-formats">
                                        <button class="ql-list" value="ordered" type="button"></button>
                                    </span>
                                    <span class="ql-formats">
                                        <button class="ql-link" value="ordered" type="button"></button>
                                    </span>
                                </div>
                            </quill-editor>
                        </div>
                    </div>
                    <div class="col-12 row d-flex justify-content-between">
                        <div class="col-md-6 col-12" *ngIf="data.actionId">
                            <div class="form-group">
                                <select class="form-control" formControlName="status" style="border: 1px solid orange;">
                                    <option value="1">Oluşturuldu</option>
                                    <option value="2">Yapılıyor</option>
                                    <option value="3">Tamamlandı</option>
                                    <option value="4">İptal Edildi</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-6 col-12 justify-content-end">
                            <button type="submit" class="btn btn-primary mr-1" rippleEffect [disabled]="actionForm.invalid">{{data.actionId ? 'Güncelle' : 'Kaydet'}}</button>
                            <button type="reset" class="btn btn-outline-secondary" rippleEffect (click)="closeModal()">İptal</button>
                        </div>

                    </div>
                </div>
            </form>
        </div>
    </div>
</div>